import React from "react";
import { Link } from "react-router-dom";
import { MotionSection } from "@/components/MotionSection";

export default function ClosingCTA() {
  return (
    <MotionSection
      id="cta"
      data-testid="section-closing-cta"
      className="bg-ice py-16 lg:py-20"
    >
      <div className="container-pc text-center">
        <p className="eyebrow justify-center inline-flex">Clean. Compact. Controlled.</p>
        <h3 className="mt-5 mx-auto max-w-3xl text-2xl sm:text-3xl lg:text-[34px] font-bold text-navy tracking-tighter leading-snug">
          Designed for customers who want a professional storage solution without bulky
          laboratory equipment.
        </h3>
        <div className="mt-8">
          <Link
            to="/product"
            data-testid="closing-cta-shop"
            className="inline-flex items-center justify-center rounded-full bg-navy text-white px-8 py-3.5 text-sm font-semibold tracking-wide hover:brightness-110 transition shadow-card"
          >
            Pre-order Now
          </Link>
        </div>
      </div>
    </MotionSection>
  );
}
